import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiDeleteArea, apiGetAreaTrashData, apiRecoverArea } from 'services/AreaService'

export const getTrashAreas = createAsyncThunk('areaTrash/data/getTrashAreas',async (data) => {
    const response = await apiGetAreaTrashData(data)
    return response.data
})

export const recoverArea = async (data) => {
    const response = await apiRecoverArea(data)
    return response.data
}

export const deleteArea = async (data) => {
    const response = await apiDeleteArea(data)
    return response.data
}

export const initialTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 10,
    query: '',
    sort: {
        order: '',
        key: ''
    }
}

export const initialState = {
    loading: false,
    areaTrash: [],
    openFeedback: '',
    tableData: initialTableData,
}

const dataSlice = createSlice({
    name: 'areaTrash/data',
    initialState,
    reducers: {
        reset: () => initialState,
        setTableData: (state, action) => {
            state.tableData = action.payload
        },
    },
    extraReducers: (builder) => {
		builder.addCase(getTrashAreas.fulfilled, (state, action) => {
            state.areaTrash = action.payload.items
            state.tableData.total = action.payload?.meta?.totalItems
            state.openFeedback = action.payload?.open_feedback
            state.loading = false
        })
        builder.addCase(getTrashAreas.pending, (state) => {
            state.loading = true
        })
    }
})

export const { reset, setTableData, setSortedColumns } = dataSlice.actions

export default dataSlice.reducer
